import { ApiError } from './api-client';

export type ViewKind = 'loading' | 'permission' | 'error' | 'empty' | 'ready';

export function deriveViewKind(loading: boolean, error: unknown, size: number): ViewKind {
  if (loading) return 'loading';
  if (error instanceof ApiError && error.isPermissionError) return 'permission';
  if (error) return 'error';
  if (size === 0) return 'empty';
  return 'ready';
}
